import { render } from "./BannerPandOne.vue?vue&type=template&id=73010bb4&scoped=true"
import script from "./BannerPandOne.vue?vue&type=script&lang=js"
export * from "./BannerPandOne.vue?vue&type=script&lang=js"

import "./BannerPandOne.vue?vue&type=style&index=0&id=73010bb4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73010bb4"]])

export default __exports__